package com.macrofocus.eflux.network

import com.macrofocus.common.units.Quantity
import com.macrofocus.eflux.network.logical.logicalBusIdOf
import com.macrofocus.eflux.network.physical.Bus
import com.macrofocus.eflux.network.physical.BusId
import org.molap.dataframe.rowmajor.RowMajorDataFrame
import kotlin.reflect.KClass

open class DerivedBusColumn(
    val name: String,
    val longName: String,
    override val type: KClass<*>,
    val value: (Bus) -> Any?,
    private val formattedValue: (Bus) -> String? = { value(it)?.toString() }
) : RowMajorDataFrame.Column<Bus,Any?> {
    fun getFormattedValue(row: Bus): String? {
        return formattedValue(row)
    }

    override fun getValue(row: Bus): Any? {
        return value(row)
    }

    override fun toString(): String {
        return "$name"
    }

    companion object {
        val datetime = DerivedBusColumn("datetime", "Date/Time", Any::class, { it.record.datetime })

        val busId = DerivedBusColumn("busId", "Bus Identifier", BusId::class, { it.id })
        val logicalBusId = DerivedBusColumn(
            "logicalBusId",
            "logicalBusId",
            BusId::class,
            { logicalBusIdOf(it.id).name })
        val longName = DerivedBusColumn("longName", "Name", String::class, { it.longName })

        //        val name = BusColumn("name", String::class) { it.record.name }
        val baskv = DerivedBusColumn("baskv", "Base voltage", Quantity::class, { it.record.baskv })
        val ide = DerivedBusColumn("ide", "Bus type code", Double::class, { it.record.ide })
        val area = DerivedBusColumn("area", "Area", Int::class, { it.record.area })
        val zonanme = DerivedBusColumn(
            "zonanme",
            "Zone",
            String::class,
            { it.zone?.name ?:  it.record.zone.toString() })
        val zone = DerivedBusColumn("zone", "zone", Int::class, { it.record.zone })
        val owner = DerivedBusColumn("owner", "Owner", Double::class, { it.record.owner })
        val v = DerivedBusColumn(
            "v",
            "Voltage",
            Quantity::class,
            { it.v }) { it.v.amount.toFixed(2) + " " + it.v.unit?.symbol }
        val vm = DerivedBusColumn("vm", "Voltage Magnitude", Quantity::class, { it.record.vm })
        val va = DerivedBusColumn("va", "Voltage Angle", Quantity::class, { it.record.va })
        val nvhi = DerivedBusColumn("nvhi", "NVHI", Quantity::class, { it.record.nvhi })
        val nvlo = DerivedBusColumn("nvlo", "NVLO", Quantity::class, { it.record.nvlo })
        val evhi = DerivedBusColumn("evhi", "EVHI", Quantity::class, { it.record.evhi })
        val evlo = DerivedBusColumn("evlo", "EVLO", Quantity::class, { it.record.evlo })

        val all : Array<DerivedBusColumn> = arrayOf(
            busId, logicalBusId, baskv, ide, area, zone, owner, vm, va, nvhi, nvlo , evhi, evlo
        )

        val table : Array<DerivedBusColumn> = arrayOf(
//            busId, logicalBusId, longName, baskv, ide, area, zonanme, owner, v, vm, va, nvhi, nvlo , evhi, evlo
            zonanme, logicalBusId, baskv, v, busId
        )

        val timeseries : Array<DerivedBusColumn> = arrayOf(
            busId, vm
        )
    }
}

